<template>
	<v-layout style = 'flex: 0 0 auto !important;'>
		<v-list-item @click.stop.prevent = 'visibility = true; getPersons();' style = 'width: 100%;' class = 'px-0'>
			<v-list-item-content class = 'pl-4'>
                <v-list-item-title class="align-center">Подключить пользователя</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class = 'pr-4'>
                <span>
                	<v-icon>add</v-icon>
                </span>
            </v-list-item-action>
        </v-list-item>
		<dialog-fullscreen :visibility.sync = 'visibility' :indicator = 'indicator'>
			<template v-slot:title>Назначить пользователя</template>
			<template v-slot:action>
				<v-btn 
					text 
					:disabled = '!valid'
					:loading = 'indicator'
					color='green darken-2' 
					@click = 'addProjectPerson'
				>
					Добавить
				</v-btn>
			</template>
			<template v-slot:content>
				<v-form v-model = 'valid' style = 'min-width: 320px; max-width: 420px;'>
					<v-select
						v-model = 'user.mode_reports'
						:items = "defaultModes"
						item-text = "text"
						item-value = "value"
						label = "Доступ к списку отчетов"
						single-line
						:rules = "[rules.required]"
					></v-select>
					<v-select
						v-model = 'user.mode_notifications'
						:items = "defaultModes"
						item-text = "text"
						item-value = "value"
						label = "Доступ к списку уведомлений"
						single-line
						:rules = "[rules.required]"
					></v-select>
					<v-select
						v-model = 'user.mode_statplaces'
						:items = "defaultModes"
						item-text = "text"
						item-value = "value"
						label = "Доступ к списку рекламных аккаунтов"
						single-line
						:rules = "[rules.required]"
					></v-select>
					<v-select
						v-model = 'user.mode_persons'
						:items = "defaultModes"
						item-text = "text"
						item-value = "value"
						label = "Доступ к списку пользователей"
						single-line
						:rules = "[rules.required]"
					></v-select>
					<v-text-field
						v-model = 'user.mode_name'
						label='Отображаемое название роли'
						:rules = "[rules.required]"
					></v-text-field>
					<v-text-field
						v-model = 'user.mode_description'
						label='Отображаемое описание роли'
					></v-text-field>
					<v-autocomplete
						v-model = 'user.uid'
						:items = 'users'
						:loading = 'indicatorSecondary'
						hide-no-data
						hide-selected
						item-text = 'placeholder'
						item-value = 'uid'
						label = 'Сотрудники компании'
						placeholder = 'Начните вводить имя сотрудника'
						:rules = "[rules.required]"
					></v-autocomplete>
				</v-form>
			</template>
		</dialog-fullscreen>
	</v-layout>
</template>

<script>
	import DialogFullscreen from '@/components/elements/dialogs/Fullscreen.vue'
	import { orderBy } from 'lodash-es'

	export default {
		name: 'UserProjectCreateMenu',
		props: ['postAction', 'project'],
		components: {'dialog-fullscreen': DialogFullscreen},
		data() {
			return {
				users: [],
				defaultModes: [
		          {'text':'Чтение','value':'R'},
		          {'text':'Изменение','value':'W'},
		          {'text':'Удаление','value':'X'},
		          {'text':'Полное управление','value':'U'}
		        ],
				visibility: false,
				user: {},
				indicator: false,
				errorCreate: false,
				errorCreateMessage: '',
				indicatorSecondary: false,
				valid: false,
				rules: {
					required: value => !!value || 'Обязательное поле.'
				}
			}
		},
		methods: {
			getPersons() {
	    		this.indicatorSecondary = true;
	    		this.$http.get(this.$store.getters.endpoint + '/db/persons', {
		          emulateJSON: true,
		          params: {'login': this.$store.getters.userLogin},
		          headers: {...this.$store.state.restrictedHeaders,...{'Authorization': 'Bearer ' + this.$store.getters.userToken}}
		        }).then( (r) => {
		          let response = r.body;
		          if (response.result) {
		          	this.indicatorSecondary = false;
		            this.users = response.data
		            this.users.map( (e) => { e.placeholder = e.name + ' ' + e.lastname})
		            this.users = orderBy(this.users, 'placeholder');
		          } else {
		            console.log(response)
		          }
		        })
	    	},
			addProjectPerson() {
				this.indicator = true;
		        let requestHeaders = {
		          'Content-Type': 'application/json;charset=UTF-8',
		          'Authorization': 'Bearer ' + this.$store.getters.userToken
		        }
			    this.$http.post(this.$store.getters.endpoint + '/db/project/' + this.project.project_id + '/persons', {
			        ...{'login': this.$store.getters.userLogin},...this.user
			        },{
			            headers: {...this.$store.state.restrictedHeaders,...requestHeaders
			        }
			    }).then( (r) => {
			        let response = r.body;
			        if (response.result) {
						this.indicator = false;
						this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'create',
                                target: 'project_user'
                            },
                            once: false
                        })
			            this.postAction('persons');
			            this.visibility = false;
			        } else {
			        	this.errorCreate = true;
                		this.errorCreateMessage = ['Идентификатор уже используется в другом объекте']
			            console.log(response)
			        }
			    }, (r) => {
			    	this.indicator = false;
			    	let error = r.body;
	        		console.log(error)
			    });
			}
		}
	}
</script>